// src/components/Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { Box } from "@mui/material";

const Layout = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navigation />
      <Box sx={{ flexGrow: 1, mt: 2, p: 2 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
